<template>
    <div id="invest-line" style="width:100%;height:100%;">
        <div style="width:100%;height:100%;" id="lineChart"></div>
    </div>
</template>

<script>
export default {
    name:'investLine',
    props: {
        currentTrend: {
            type: String
        },
        currentYear: {
            type: String
        },
        chooseData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data(){
        return{
            myChart: '',
            firstFlag: false
        }
    },
    watch: {
        chooseData: {
            handler(newData) {
                if (newData && newData.length > 0) {
                    const _this = this;
                    
                    let min = this.chooseData[0].value,
                    minDate = this.chooseData[0].date,
                    maxDate = this.chooseData[this.chooseData.length - 1].date,
                    min1 = '',
                    min2 = '',
                    dateArr = [],
                    valueArr = [];
                    this.chooseData.forEach((item) => {
                        min = min > item.value ? item.value : min;
                        minDate = min > item.value ? item.date : minDate;
                    })
                    let tempData = [...this.chooseData];
                    tempData.sort((a, b) => a.value - b.value);

                    let len = tempData.length;
                    let obj = tempData[Math.floor(len * 0.3)];
                    min1 = obj.value;

                    obj = tempData[Math.floor(len * 0.7)];
                    min2 = obj.value;

                    valueArr.push(min, min1, min2);
                    dateArr.push(minDate, maxDate);
                    
                    if(!this.myChart){
                        this.myChart = D3Charts.init("lineChart");
                    }
                    this.myChart.setOption(this.setOption(dateArr, valueArr));

                    let line = this.myChart.getModel('axis', 0);
                    this.myChart.registerAction(line, "AXIS_MOVE", function(d) {
                        let obj = {
                            date: d.axisData,
                            value: d.data.series[0].value[1]
                        }
                        if (_this.firstFlag === false) {
                            _this.firstFlag = true;
                            _.log().clickStat(`${_this.currentTrend}.${_this.currentYear}.chart`);
                        }
                        document.body.style.overflow = 'hidden';
                        _this.$emit('changTabFlag', false, obj);
                    });
                    this.myChart.registerAction(line, "AXIS_OUT", function() {
                        document.body.style.overflow = 'auto';
                        _this.firstFlag = false;
                        let timer = setTimeout(() => {
                            _this.$emit('changTabFlag', true);
                            clearTimeout(timer);
                        }, 300);
                    });

                }
            },
            deep: true
        }
    },
    methods:{
        setOption(dateArr, valueArr){
            let option;
            // let len = this.chooseData.length;
            // let xIndex = this.chooseData[len - 1].date;
            // let yValue = this.chooseData[len - 1].value;
            option = {
                "data": [{
                    "originData": [...this.chooseData]
                }],
                "grid": [{
                    "top": "20",
                    "left": "42",
                    "right": "4",
                    "bottom": "30"
                }],
                "series": [{
                    "type": "line",
                    "$dataIndex": 0,
                    "dataKey": "value",
                    "$axisIndex": [0,
                        1],
                    "symbol": {
                        "normal": {
                            "show": false,
                            "size": 6,
                            "style": {
                                "fill": "white",
                                "stroke": "rgb(0, 128, 255)",
                                "lineWidth": 2
                            }
                        },
                        "emphasis": {
                            "show": true,
                            "size": 6,
                            "style": {
                                "fill": "rgb(0, 128, 255)",
                                "stroke": "rgb(0, 128, 255)"
                            }
                        }
                    },
                    "line": {
                        "show": true,
                        "style": {
                            "normal": {
                                "stroke": "rgb(0, 128, 255)",
                                "lineWidth": 2
                            }
                        }
                    },
                }],
                "dataZoom": [{}],
                // "markPoint": [{
                //     "$axisIndex": [0,
                //         1],
                //     "$seriesIndex": 0,
                //     "symbol": {
                //         "style": {
                //             "normal": {
                //                 "fill": "#0A85FF"
                //             },
                //             "emphasis": {
                //                 "show": true,
                //                 "fill": "#0A85FF"
                //             }
                //         }
                //     },
                //     "label": {
                //         "normal": {
                //             "show": true,
                //             "style": {
                //                 "fill": "white",
                //                 "position": "inside"
                //             }
                //         },
                //         "emphasis": {
                //             "show": false
                //         }
                //     },
                //     "data": [
                //         {
                //             "xIndex": len - 1,
                //             "symbol": {
                //                 "offset": [-19,
                //                 -20],
                //                 "type": "path://M2,16.5 L24,16.5 L28,20, L28,2 A 2 2 0 0 0 26 0 L2,0 A 2 2 0 0 0 0 2 L0,14.5 A 2 2 0 0 0 2 16.5 Z"
                //             },
                //             "label": {
                //                 "normal": {
                //                     "show": true,
                //                     "style": {
                //                         "position": "inside",
                //                         "fill": "#ffffff",
                //                         "textOffset": [0,
                //                             -2]
                //                     },
                //                     "formatter": function(d) {
                //                         return Number(d.yValue).toFixed(2);
                //                     }
                //                 },
                //                 "emphasis": {
                //                     "show": true,
                //                     "style": {
                //                         "fill": "#ffffff",
                //                     }
                //                 }
                //             },
                //         },
                //     ]
                // }],
                "axis": [{
                    "position": "bottom",
                    "type": "point",
                    "$dataIndex": 0,
                    "dataKey": "date",
                    "tickValues": dateArr,
                    "tick": {
                        "show": false,
                    },
                    "line": {
                        "show": true,
                        "style": {
                            "stroke": "rgba(0, 0, 0, 0.05)",
                            "lineWidth": 1
                        }
                    },
                    "label": {
                        "show": true,
                        "inRange": true,
                        "padding": 12,
                        "style": {
                            "fill": "#999999",
                            "fontSize": 12,
                            "fontWeight": "500"
                        },
                        "formatter": function(d){
                            let value = d.slice(0, 4) + '-' + d.slice(4, 6) + '-' + d.slice(6, 8);
                            return value
                        },
                    },
                    "splitLine": {
                        "show": false,
                    },
                    "splitArea": {
                        "show": false,
                    },
                    "name": {
                        "show": false,
                    }
                },
                {
                    "position": "left",
                    "type": "linear",
                    "xOrY": "y",
                    "min": valueArr[0],
                    "tickValues": valueArr,
                    "tick": {
                        "show": false,
                    },
                    "line": {
                        "show": false,
                    },
                    "label": {
                        "show": true,
                        "padding": 12,
                        "style": {
                            "fill": "#999999",
                            "fontSize": 12,
                            "fontWeight": "500"
                        }
                    },
                    "splitLine": {
                        "show": false,
                    },
                    "splitArea": {
                        "show": true,
                        "style": {
                            "color": ["rgba(0, 187, 29, 0.08)", "rgba(250, 165, 0, 0.08)", "rgba(255, 51, 10, 0.08)"]
                        }
                    },
                    "name": {
                        "show": false,
                    }
                }],
                "axisPointer": [{
                    "$axisIndex": 0,
                    "shadow": {
                        "show": true,
                        "style": {
                            "fill": "rgba(5,83,161,0.1)"
                        }
                    },
                    "line": {
                        "show": true,
                        "style": {
                            "stroke": "#0080FF",
                            "fill": "#0080FF",
                            "lineDash": [2, 5]
                        }
                    },
                    "label": {
                        "show": true,
                        "gap": 8,
                        "inRange": true,
                        "style": {
                            "fill": "#FFFFFF",
                            "textBackgroundColor": "#0080FF",
                            "fontWeight": 460,
                            "fontSize": 12,
                            "textOffset": ['100', 200]
                        }
                    }
                }, {
                    "$axisIndex":1,
                    "$axisPointerIndex": 0,
                    "$seriesIndex": 0,
                    "shadow": {
                        "show": true,
                        "style": {
                            "fill": "rgba(5,83,161,0.1)"
                        }
                    },
                    "line": {
                        "show": true,
                        "style": {
                            "stroke": "#0080FF",
                            "fill": "#0080FF",
                            "lineDash": [2, 5]
                        }
                    },
                    "label": {
                        "show": true,
                        "gap": 8,
                        "inRange": true,
                        "style": {
                            "fill": "#FFFFFF",
                            "textBackgroundColor": "#0080FF",
                            "fontWeight": 460,
                            "fontSize": 12,
                            "textOffset": ['100', 200]
                        }
                    }
                }],
                "textStyle": {
                    "fill": "#999999",
                    "fontFamily": "THSMoneyfont-Medium",
                    "fontSize": 12,
                    "fontStyle": "normal",
                    "fontWeight": "normal"
                }
            }
            return option
        }
    },
    mounted(){
        
        const _this = this;
        this.myChart = D3Charts.init("lineChart");
        let min = this.chooseData[0].value,
        minDate = this.chooseData[0].date,
        maxDate = this.chooseData[this.chooseData.length - 1].date,
        min1 = '',
        min2 = '',
        dateArr = [],
        valueArr = [];
        this.chooseData.forEach((item) => {
            min = min > item.value ? item.value : min;
            minDate = min > item.value ? item.date : minDate;
        })
        let tempData = [...this.chooseData];
        tempData.sort((a, b) => a.value - b.value);

        let len = tempData.length;
        let obj = tempData[Math.floor(len * 0.3)];
        min1 = obj.value;

        obj = tempData[Math.floor(len * 0.7)];
        min2 = obj.value;

        valueArr.push(min, min1, min2);
        dateArr.push(minDate, maxDate);
        this.myChart.setOption(this.setOption(dateArr, valueArr));
        
        let line = this.myChart.getModel('axis', 0);
        this.myChart.registerAction(line, "AXIS_MOVE", function(d) {
            let obj = {
                date: d.axisData,
                value: d.data.series[0].value[1]
            }
            if (_this.firstFlag === false) {
                _this.firstFlag = true;
                _.log().clickStat(`${_this.currentTrend}.${_this.currentYear}.chart`);
            }
            
            document.body.style.overflow = 'hidden';
            _this.$emit('changTabFlag', false, obj);
        });

        this.myChart.registerAction(line, "AXIS_OUT", function() {
            document.body.style.overflow = 'auto';
            _this.firstFlag = false;
            let timer = setTimeout(() => {
                _this.$emit('changTabFlag', true);
                clearTimeout(timer);
            }, 300);
        });
        
    }
}
</script>

<style scoped>
</style>